/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetAnthropicInferenceConfigRequest,
  GetAnthropicInferenceConfigSecurity,
} from "../models/operations/getanthropicinferenceconfig.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  AnthropicInferenceConfigQueryData,
  buildAnthropicInferenceConfigQuery,
  prefetchAnthropicInferenceConfig,
  queryKeyAnthropicInferenceConfig,
} from "./anthropicInferenceConfig.core.js";
export {
  type AnthropicInferenceConfigQueryData,
  buildAnthropicInferenceConfigQuery,
  prefetchAnthropicInferenceConfig,
  queryKeyAnthropicInferenceConfig,
};

export type AnthropicInferenceConfigQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getAnthropicInferenceConfig aiIntegrations
 *
 * @remarks
 * Get the organization Anthropic inference hook setup.
 */
export function useAnthropicInferenceConfig(
  request?: GetAnthropicInferenceConfigRequest | undefined,
  security?: GetAnthropicInferenceConfigSecurity | undefined,
  options?: QueryHookOptions<
    AnthropicInferenceConfigQueryData,
    AnthropicInferenceConfigQueryError
  >,
): UseQueryResult<
  AnthropicInferenceConfigQueryData,
  AnthropicInferenceConfigQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildAnthropicInferenceConfigQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getAnthropicInferenceConfig aiIntegrations
 *
 * @remarks
 * Get the organization Anthropic inference hook setup.
 */
export function useAnthropicInferenceConfigSuspense(
  request?: GetAnthropicInferenceConfigRequest | undefined,
  security?: GetAnthropicInferenceConfigSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    AnthropicInferenceConfigQueryData,
    AnthropicInferenceConfigQueryError
  >,
): UseSuspenseQueryResult<
  AnthropicInferenceConfigQueryData,
  AnthropicInferenceConfigQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildAnthropicInferenceConfigQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setAnthropicInferenceConfigData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
    },
  ],
  data: AnthropicInferenceConfigQueryData,
): AnthropicInferenceConfigQueryData | undefined {
  const key = queryKeyAnthropicInferenceConfig(...queryKeyBase);

  return client.setQueryData<AnthropicInferenceConfigQueryData>(key, data);
}

export function invalidateAnthropicInferenceConfig(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "aiIntegrations",
      "getAnthropicInferenceConfig",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllAnthropicInferenceConfig(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "aiIntegrations", "getAnthropicInferenceConfig"],
  });
}
